<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      highlight-current-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 42"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :tree-config="{ children: 'children', reserve: true }"
      @current-change="onCurrentChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.categoryStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.categoryStatusName }}
        </el-tag>
      </template>
      <template v-slot:isEcom="{ row }">
        <el-tag
          v-if="row.isEcom"
          size="mini"
          :type="row.isEcom === 'Y' ? 'light' : 'warning'"
        >
          {{ row.isEcomName }}
        </el-tag>
      </template>
      <template v-slot:isLast="{ row }">
        <el-tag
          v-if="row.isLast"
          size="mini"
          :type="row.isLast === 'Y' ? 'light' : 'warning'"
        >
          {{ row.isLastName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  code: row.categoryCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  code: row.categoryCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-show="row.categoryStatus === 'Y'"
            v-if="allow('D')"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.categoryCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          width: 110,
          slots: {
            default: 'opt',
          },
        },
        {
          title: this.$l('table_label_category_no') || '分类编号',
          field: 'categoryNo',
          minWidth: 80,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('table_label_category_name') || '分类名称',
          field: 'categoryName',
          minWidth: 160,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('table_label_category_name_en') || '分类名称英文',
          field: 'categoryNameEn',
          minWidth: 180,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('table_label_class_level') || '层级',
          field: 'classLevel',
          width: 60,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('table_label_is_last') || '末级',
          field: 'isLast',
          width: 60,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          slots: { default: 'isLast' },
        },
        {
          field: 'isEcomName',
          align: 'center',
          width: 120,
          title: this.$l('table_label_is_Amazon') || '是否亚马逊使用',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          slots: { default: 'isEcom' },
        },
        {
          field: 'categoryStatus',
          align: 'center',
          width: 80,
          title: this.$l('table_label_status') || '有效状态',
          slots: { default: 'status' },
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'createBy',
          align: 'center',
          minWidth: 120,
          title: this.$l('table_label_create_by') || '创建人',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'createDate',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_create_date') || '创建时间',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'modifyBy',
          align: 'center',
          minWidth: 120,
          title: this.$l('table_label_modify_by') || '修改人',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'modifyDate',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_modify_date') || '修改时间',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
      ],
    }
  },
  methods: {
    del(categoryCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.masCategoryDelApi({ categoryCode }).then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    onCurrentChange({ row }) {
      this.$emit('selectList', row)
    },
    onCurrentCategoryTreeChange() {
      this.$eventBus.$emit('selectCategoryTreeList')
    },
  },
}
</script>
